<template>
    <div class="total-tracing">
        <Card class="p-m-3" :class="{'card-loading': isLoading}">

            <template #title>
                <div style="height: .5em;     margin: -0.5em; ">
                    <ProgressBar
                            class="p-m-0 p-p-0"
                            v-if="isLoading"
                            mode="indeterminate"
                            style="height: .5em"
                    />
                </div>
                <h2>תיק אישי </h2>
            </template>
            <template #content>
                <h3 class="no-content" v-if="!isLoading && subjectTracingSort.length === 0">אין נתונים להצגה</h3>

                <div class="p-grid">
                    <div
                            @click="moveToData(status)"
                            class="p-col-12 p-sm-12 p-md-6 p-lg-6"
                            v-for="status in subjectTracingSort"

                            :key="status.id">

                        <div
                                v-tooltip.top="'לחץ לצפיה באירועים'"
                                class="p-p-3  p-card item subject-tracking"
                             :class="(status.type)">
                            <h1 style="text-align: center">
                                {{ getPresenceTotal(status) }}
                            </h1>
                            <h2 style="text-align: center">
                                {{ status.hebrewName }}
                            </h2>
                        </div>
                    </div>
                </div>

                <!--        <div v-for="status in subjectTracingSort" :key="status.id">-->
                <!--          <div :class="(status.type)" class="p-grid">-->
                <!--            <h3 :class="(status.type)" class="subject-tracking p-pr-5 p-col-9"-->
                <!--			 :style="{-->
                <!--              color:-->
                <!--            status.color }">-->
                <!--              {{ status.hebrewName }}-->
                <!--            </h3>-->
                <!--            <h3 class="p-pl-5 p-col subject-tracking" style="text-align: left"-->
                <!--			 :class="(status.type)"-->
                <!--			 :style="{ color: status.color }">-->
                <!--              {{ getPresenceTotal(status) }}-->
                <!--            </h3>-->
                <!--&lt;!&ndash;            <Divider type="dashed" class="divider-short-dialog" />&ndash;&gt;-->
                <!--          </div>-->
                <!--        </div>-->
            </template>
        </Card>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Service from "@/service/Service";

export default {
    service: null,

    name: "total-tracing-card",
    props: {pupil: Object, startDate: Number, endDate: Number},
    components: {},
    data() {
        return {
            isLoading: false,
            totalTracing: null,
        };
    },
    created() {
    },
    mounted() {
        this.service = new Service();
        if (this.pupil) {
            this.getTotalTracing();
        }
    },
    methods: {
        moveToData(status) {
            const routeData = this.$router.resolve({
                name: 'tracing',
                query: {
                    pupil: this.pupil.id,
                    subject: status.id,
                    start: this.startDate,
                    end: this.endDate,
                }
            })
            window.open(routeData.href, '_blank');
        },
        getPresenceTotal(status) {
            if (this.totalTracing) {
                return this.totalTracing.find((p) => p.id === status.id)?.total || 0;
            } else {
                return '---'
            }
        },
        getTotalTracing() {
            this.isLoading = true
            this.service
                .getTotalTracingPupil(this.pupil.id, this.startDate, this.endDate)
                .then((data) => {
                    data?.map((e) => (e.status = this.getStatusObj(e.id)));
                    data?.sort((a, b) => (a.status?.sort > b.status?.sort ? 1 : -1));
                    this.totalTracing = data;
                    this.isLoading = false

                });
        },
        getStatusObj(statusId) {
            return this?.subjectTracing?.find(
                (subject) => subject.id === statusId
            );
        },
    },
    computed: {
        subjectTracingSort() {
            if (this.subjectTracing) {
                const subjectTracingFilter = this.subjectTracing?.filter(t => this.getPresenceTotal(t) > 0)
                return subjectTracingFilter?.sort((a, b) => {
                    if (a.type > b.type) {
                        return 1
                    } else if (a.type < b.type) {

                        return -1
                    }
                    return 0

                })
            }
        },
        ...mapState(["subjectTracing"]),
    },
    watch: {
        pupil() {
            this.getTotalTracing();
        },
        startDate() {
            this.getTotalTracing();
        },
        endDate() {
            this.getTotalTracing();
        },
    },
};
</script>

<style scoped>
.item{
    cursor: context-menu;
}
.no-content {
    text-align: center;
    color: #999999;
}
</style>
